import React from 'react';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { FormHelperText, MenuItem, SxProps, Typography, styled } from '@mui/material';
import { Spacer } from '../new/Spacer';

interface SettingsSelectProps {
  label: string;
  data: string[] | undefined;
  onChange: (event: SelectChangeEvent<string>) => void;
  value: string | undefined;
  error: string | undefined;
  styles?: any;
  disabled?: boolean;
  required?: boolean;
  containerSX?: SxProps;
  autoComplete?: string;
}

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  max-width: 100%;
  gap: 0.25rem;
`;

const SettingsSelect: React.FC<SettingsSelectProps> = ({
  label,
  data,
  onChange,
  value,
  error,
  disabled,
  required = false,
  containerSX,
  autoComplete
}) => {
  return (
    <Container sx={containerSX}>
      {label && (
        <Typography
          sx={{
            fontSize: '0.875rem',
            fontWeight: 600,
            fontFamily: 'Instrument Sans',
            lineHeight: '1.25rem',
            color: error ? '#AC3737' : '#45464F',
          }}
        >
          {label}
          {required ? '*' : null}
        </Typography>
      )}
      <Select
        variant="outlined"
        disabled={disabled}
        onChange={onChange}
        value={value}
        autoComplete={autoComplete}
        error={true}
        sx={{
          width: '100%',
          '& .MuiSelect-select span::before': {
            content: "'Select...'",
            color: '#7E828B',
          },
          '& .MuiInputBase-input': {
            borderRadius: '0.375rem',
            border: error ? '0.0625rem solid #AC3737' : '0.0625rem solid #7E828B',
            fontSize: '1rem',
            fontWeight: 400,
            fontFamily: 'Instrument Sans',
            lineHeight: '1.5rem',
            padding: '0.75rem 1rem',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
        }}
      >
        {data !== undefined
          ? data.map((item) => {
              return (
                <MenuItem key={`option_${item}`} value={item}>
                  {item}
                </MenuItem>
              );
            })
          : null}
      </Select>
      {error ? (
        <FormHelperText
          sx={{
            color: '#AC3737',
            marginTop: 0,
            fontFamily: 'Instrument Sans',
            fontSize: '0.875rem',
            lineHeight: '1rem',
            height: '1.5rem',
          }}
        >
          {error}
        </FormHelperText>
      ) : (
        <Spacer h={24} />
      )}
    </Container>
  );
};

export default SettingsSelect;
